
import React from 'react';
import { Clock, Utensils, Users } from 'lucide-react';
import { FoodRecipe } from '@/services/recipes/types';

interface RecipeHeaderProps {
  recipe: FoodRecipe;
  currentLang: string;
}

const RecipeHeader: React.FC<RecipeHeaderProps> = ({ recipe, currentLang }) => {
  const name = recipe[`name_${currentLang}`] || recipe.name;
  const description = recipe[`description_${currentLang}`] || recipe.description;

  return (
    <>
      {recipe.image_url && (
        <div className="mb-4 -mx-4 h-56 relative">
          <img 
            src={recipe.image_url} 
            alt={name} 
            className="w-full h-full object-cover"
          />
        </div>
      )}
      <h2 className="font-medium text-lg mb-2">{name}</h2>

      <div className="flex flex-wrap gap-2 mb-4">
        <div className="flex items-center text-xs bg-gray-100 px-2 py-1 rounded-full text-gray-700">
          <Clock className="w-3 h-3 mr-1" />
          <span>{recipe.preparation_time}</span>
        </div>
        <div className="flex items-center text-xs bg-gray-100 px-2 py-1 rounded-full text-gray-700">
          <Utensils className="w-3 h-3 mr-1" />
          <span>{recipe.difficulty}</span>
        </div>
        <div className="flex items-center text-xs bg-gray-100 px-2 py-1 rounded-full text-gray-700">
          <Users className="w-3 h-3 mr-1" />
          <span>{recipe.serving_size}</span>
        </div>
      </div>
      
      <p className="text-sm text-gray-700 mb-6">{description}</p>
    </>
  );
};

export default RecipeHeader;
